exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-container .info-container[data-v-0e3ee68e]{height:40px;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:16px;font-weight:bold;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.list-container .info-container .count[data-v-0e3ee68e]{margin-left:20px}", ""]);

// exports
